import React from 'react';
import * as styles from './styles/styles.module.scss';
import * as linkStyles from '../../../styles/linkStyles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function CardDescription({ className, name, description, showMoreUrl }) {
  if (!description) {
    return null;
  }
  const classes = ['xlate-none', styles.description];
  if (className) {
    classes.push(className);
  }
  // Note: 'Show more' just utilizes trail card's default click funcitonality
  return (
    <div title={`${StringConstantsMixin.strings.TAB_NAMES.DESCRIPTION} - ${name}`} className={classes.join(' ')}>
      {description}
      <a
        className={`${styles.showMore} ${linkStyles.showMore}`}
        href={showMoreUrl}
        target="_blank"
        title={`${StringConstantsMixin.strings.SHOW_MORE} - ${name}`}
      >
        {StringConstantsMixin.strings.SHOW_MORE}
      </a>
    </div>
  );
}
